import { useContext } from 'react'
import { ProfileContext } from '../../context/ProfileContext'
import './AccountCard.css'

const AccountCard = () => {
    const { profile } = useContext(ProfileContext)

    const shortenWalletAddress = address => {
        // Ignore if no address provided
        if (!address || !address.length) return ''

        const start = address.substring(0, 6)
        const end = address.substring(address.length - 4, address.length)
        return `${start}...${end}`
    }

    return (
        <div className="account-card">
            <div className="avatar">
                <img src={profile.picUri} alt={`Profile for ${profile.name}`} />
            </div>
            <div className="details">
                <div className="account-name">{profile.name}</div>
                <div className="address">{shortenWalletAddress(profile.id)}</div>
            </div>
        </div>
    )
}

export default AccountCard
